import { BaseDto } from '../base.dto';

export class PurchaseOrderEmailLogDto extends BaseDto {
  purchaseOrderId: number;
  receivingEmail: string;
  emailStatus: string;
  eventDate: Date;
  templateId: number;
  messageId: string;
  emailType?: {
    name: string;
  };
}
